(() => {
  'use strict';

  const UPCART_CONTRAST_CSS = `
    .upcart-internal-component-upsell-tile__price-compare-at,
    .upcart-public-component-upsell-tile__price-compare-at { color: #595550 !important; }
    .upcart-internal-cart-items__key-value-pair { color: #474441 !important; }
  `;

  const processedShadowRoots = new WeakSet();

  const injectContrastCSS = (shadowRoot) => {
    if (shadowRoot.querySelector('#a11y-contrast-fix')) return;
    const style = document.createElement('style');
    style.id = 'a11y-contrast-fix';
    style.textContent = UPCART_CONTRAST_CSS;
    shadowRoot.appendChild(style);
  };

  const replaceHeading = (el, newTag) => {
    const replacement = document.createElement(newTag);
    for (const { name, value } of el.attributes) {
      replacement.setAttribute(name, value);
    }
    replacement.innerHTML = el.innerHTML;
    el.parentNode.replaceChild(replacement, el);
  };

  const fixUpcartHeading = (shadowRoot) => {
    const cartTitle = shadowRoot.querySelector('h3[data-upcart-chunk="header-title-content"]');
    if (cartTitle) replaceHeading(cartTitle, 'h2');

    const productTitles = shadowRoot.querySelectorAll('h4.upcart-internal-component-product-tile__product-title');
    for (const title of productTitles) {
      replaceHeading(title, 'h3');
    }
  };

  const fixRemoveButtons = (root) => {
    const btns = root.querySelectorAll('.upcart-internal-component-product-tile__remove-button:not([aria-label])');
    for (const btn of btns) {
      btn.setAttribute('aria-label', 'Remove item');
    }
  };

  const fixSlickTracks = (root) => {
    const tracks = root.querySelectorAll('.slick-track[role="listbox"]:not([aria-label])');
    for (const track of tracks) {
      const heading = track.closest('[data-product-title]');
      let label = heading ? `${heading.getAttribute('data-product-title')} image gallery` : null;

      if (!label) {
        let container = track.parentElement;
        while (container && container !== document.body) {
          const h = container.querySelector('h1, h2, [class*="product__title"], [class*="product-title"]');
          if (h?.textContent.trim()) {
            label = `${h.textContent.trim()} image gallery`;
            break;
          }
          container = container.parentElement;
        }
      }
      track.setAttribute('aria-label', label || 'Image gallery');
    }
  };

  const fixReploSelects = (root) => {
    const selects = root.querySelectorAll('[data-replo-variant-select-dropdown="true"]:not([aria-label])');
    for (const sel of selects) {
      const ancestor = sel.closest('[data-replo-product-handle]');
      const handle = ancestor?.getAttribute('data-replo-product-handle') || '';
      const label = handle
        ? `Select ${handle.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase())} variant`
        : 'Select variant';
      sel.setAttribute('aria-label', label);
    }
  };

  const processShadowRoot = (shadowRoot) => {
    if (processedShadowRoots.has(shadowRoot)) return;
    processedShadowRoots.add(shadowRoot);

    injectContrastCSS(shadowRoot);
    fixRemoveButtons(shadowRoot);
    fixUpcartHeading(shadowRoot);

    const obs = new MutationObserver(() => {
      fixRemoveButtons(shadowRoot);
      fixUpcartHeading(shadowRoot);
    });
    obs.observe(shadowRoot, { childList: true, subtree: true });
  };

  const scanShadowHosts = (root) => {
    const scope = root === document ? document.documentElement : root;
    if (!scope?.querySelectorAll) return;

    for (const el of scope.querySelectorAll('*')) {
      if (el.shadowRoot) {
        processShadowRoot(el.shadowRoot);
        scanShadowHosts(el.shadowRoot);
      }
    }
  };

  fixReploSelects(document);
  fixSlickTracks(document);
  scanShadowHosts(document);

  const sweepTimer = setInterval(() => {
    const upCart = document.getElementById('upCart');
    if (upCart?.shadowRoot) {
      processShadowRoot(upCart.shadowRoot);
      clearInterval(sweepTimer);
    }
  }, 300);

  setTimeout(() => clearInterval(sweepTimer), 12000);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes' && mutation.target.classList?.contains('slick-track')) {
        fixSlickTracks(mutation.target.parentElement || document);
        continue;
      }

      for (const node of mutation.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;

        const targetScope = node.querySelectorAll ? node : document;
        fixReploSelects(targetScope);
        fixSlickTracks(targetScope);

        if (node.shadowRoot) {
          processShadowRoot(node.shadowRoot);
          scanShadowHosts(node.shadowRoot);
        }
        scanShadowHosts(node);
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['role'],
  });
})();